import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';
import { CustomerRegister } from './add-customer/customerRegister.model';
import { Messages } from './messages.model';
import { SystemData } from './systemData.model';

@Injectable({
  providedIn: 'root'
})
export class OptionService {

  Send_notification_headers: any
  constructor(private http: HttpClient, private global: Globle, private localStorage: LocalStorageService) {

    this.Send_notification_headers =
      new HttpHeaders().set("Authorization", "key=AAAAiPohkq8:APA91bED3WZCyfSIhNCzgA9P0nnwXUoy38ufQfIsu_PmTpsvskrCfv74PbjFt5PSojfd2QVR-_mci7eNO-93-xAABheP4CNtD1YSQRM66e6IEDPHhLOtmG3s1cl5x5YFZ2YRmMrSQGHo")

  }


  getAllCustomers(userId: string) {
    return this.http.get<[]>(this.global.APIURL + "users/customerlist/" + userId);
  }

  getAllMandoobs() {
    return this.http.get<[]>(this.global.APIURL + "users/mandoobslist");
  }

  updateUserBalance(obj: any) {
    return this.http.put(this.global.APIURL + "users/updateuserbalance", obj);
  }

  getMessages() {
    return this.http.get<Messages[]>(this.global.APIURL + "messages");
  }

  getNotSeenMessageCount() {
    return this.http.get<number>(this.global.APIURL + "messages/getnotseen");
  }

  deleteMessages(id: number) {
    return this.http.delete(this.global.APIURL + "messages/" + id);
  }

  deleteAllMessages() {
    return this.http.delete(this.global.APIURL + "messages/deleteall");
  }

  updateStatusMessage(id: number, status: number, rejectReason: string) {
    return this.http.put<any>(this.global.APIURL + "messages/updatestatus/" + id + "?status=" + status + "&rejectReason=" + rejectReason, null);
  }

  updateNotSeenMessage() {
    return this.http.put<any>(this.global.APIURL + "messages/updatenotseen", null);
  }

  getDefinitions() {
    return this.http.get<SystemData>(this.global.APIURL + "definitions");
  }

  updateDefinitions(systemData: SystemData) {
    return this.http.put(this.global.APIURL + "definitions", systemData);
  }

  approvedUser(userId: string, userCategoryId: number, mandoobId: number) {

    return this.http.put(this.global.APIURL + "users/approve/" + userId + "/" + userCategoryId + "/" + mandoobId, "");
  }

  getUserCategory() {
    return this.http.get<[]>(this.global.APIURL + "usercategory");
  }

  updateUserCategory(userId: string, userCategoryId: number, mandoobId: number) {
    return this.http.put(this.global.APIURL + "users/updatecategory/" + userId + "/" + userCategoryId + "/" + mandoobId, "");
  }

  deleteUser(userId: string) {
    return this.http.delete(this.global.APIURL + "identity/delete/" + userId);
  }

  ChangeUserStatus(obj: any) {
    return this.http.put(this.global.APIURL + "identity/changeuserstatus", obj);
  }

  // sendNotification(obj: any) {
  //   return this.http.post("https://fcm.googleapis.com/fcm/send", obj, { headers: this.Send_notification_headers });
  // }

  sendPushNotification(obj: any) {
    return this.http.post(this.global.APIURL + "pushnotification/send", obj);
  }


  createNotifications(notification: any) {
    return this.http.post(this.global.APIURL + "notification", notification);
  }

  getNotifications() {
    return this.http.get<any[]>(this.global.APIURL + "notification");
  }

  deleteNotification(id: number) {
    return this.http.delete(this.global.APIURL + "notification/" + id);
  }

  registerCustomer(customerReg: CustomerRegister) {
    return this.http.post(this.global.APIURL + "identity/registerbyadmin", customerReg);
  }

  createPermNotifications(permNotification: any) {
    return this.http.post(this.global.APIURL + "permnotification", permNotification);
  }

  sendOneByOneSMS(mobileNo: string, message: string) {
    return this.http.get<any>(this.global.APIURL + "sms/sendOneByOneSMS?mobileNo=" + mobileNo
      + "&message=" + message);
  }

  sendBulkSMS(obj: any) {
    return this.http.post<any>(this.global.APIURL + "sms/sendbulkSMS", obj);
  }

  getSMSBallance() {
    return this.http.get<any>(this.global.APIURL + "sms/SMSBallance");
  }

  getSystemSettings(key: string) {
    return this.http.get<any>(this.global.APIURL + "systemsetting/" + key);
  }

  updateSystemSettings(obj: any) {
    return this.http.put<any>(this.global.APIURL + "systemsetting/", obj);
  }

  resetUserPassword(obj: any) {
    return this.http.post<any>(this.global.APIURL + "identity/resetpassword", obj);
  }

  changeCustomerToMandoob(userId: string) {
    return this.http.put<any>(this.global.APIURL + "identity/changecustomertomandoob/" + userId, null);
  }

  logoutFromAllDevices(userId: string) {
    return this.http.put<any>(this.global.APIURL + "identity/logoutfromalldevices/" + userId, null);
  }

}
